module.exports = __webpack_public_path__ + "static/assets/516274ebe91f61197ef4c62d1dc2024a.svg";